import { BaseReducer } from '@identic/api';
import { CertaintyLevelState, CertaintyLevelInitialState, CertaintyLevelActions } from './certainty-level.state';

export function CertaintyLevelReducer(state: CertaintyLevelState = CertaintyLevelInitialState, action: any): CertaintyLevelState {
  return BaseReducer(state, action, CertaintyLevelActions);
}
// console.log(`%cCertaintyLevelReducer::ngOnInit`, 'background:yellow');
